export function checkTextLength(text) {
  let length = 0;
  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i);
    // 判断字符是否为中文字符
    if (charCode >= 0x4e00 && charCode <= 0x9fa5) {
      length += 2;
    } else {
      length += 1;
    }
  }
  return length > 3000;
}
